import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 22,
			height: 16,
			fill: "#BA0C2F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 0h4v16H6zM0 6h22v4H0z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 0h2v16H7zM0 7h22v2H0z",
			fill: "#00205B"
		})
	]
});
export default SvgNo;
